export const WIZARD_COMMUNITY_ID = "8";
